module.exports = __webpack_public_path__ + "src/img/logo.b6ac3c4c.png";